import {
  AgentPresenceMetric,
  DailyConversationsMetric,
  PendingConversationsMetric,
  QueuedTimeMetric,
  QueueMetric,
  QueueMetricType,
  ResponseTimeMetric,
} from 'lib-dashboard-types';

export const convertMetricsToMap = (metrics?: readonly QueueMetric[]) =>
  ({
    agent_presence: metrics?.find(isAgentPresenceMetric),
    daily_conversations: metrics?.find(isDailyConversationsMetric),
    pending_conversations: metrics?.find(isPendingConversationsMetric),
    queued_time: metrics?.find(isQueuedTimeMetric),
    response_time: metrics?.find(isResponseTimeMetric),
  } satisfies { [key in QueueMetricType]: unknown });

export const isDailyConversationsMetric = (
  metric: QueueMetric,
): metric is DailyConversationsMetric => metric.type === 'daily_conversations';

export const isAgentPresenceMetric = (
  metric: QueueMetric,
): metric is AgentPresenceMetric => metric.type === 'agent_presence';

export const isPendingConversationsMetric = (
  metric: QueueMetric,
): metric is PendingConversationsMetric =>
  metric.type === 'pending_conversations';

export const isQueuedTimeMetric = (
  metric: QueueMetric,
): metric is QueuedTimeMetric => metric.type === 'queued_time';

export const isResponseTimeMetric = (
  metric: QueueMetric,
): metric is ResponseTimeMetric => metric.type === 'response_time';
